<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#8BC34A"
      d="M19 38c0 0-1.938-4-7-4s-7 4-7 4v2h14V38zM43 38c0 0-1.938-4-7-4s-7 4-7 4v2h14V38z"
    />
    <path
      fill="#FFA726"
      d="M16 12c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4S16 9.791 16 12M40 12c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4S40 9.791 40 12"
    />
    <path
      fill="#33691E"
      d="M19 21c0 0-1.938-4-7-4s-7 4-7 4v2h14V21zM43 21c0 0-1.938-4-7-4s-7 4-7 4v2h14V21z"
    />
    <g>
      <path
        fill="#FFB74D"
        d="M16 29c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4S16 26.791 16 29M40 29c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4S40 26.791 40 29M28 21c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4S28 18.791 28 21"
      />
    </g>
    <path fill="#689F38" d="M31,30c0,0-1.938-4-7-4c-5.062,0-7,4-7,4v2h14V30z" />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "UserGroupsIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
